module.exports = __webpack_public_path__ + "img/bn23.7fd9bb1d.png";